function SkeletonProduct(){

return (
<div className="animate-pulse">

  <div className="bg-gray-200 h-64 rounded-lg mb-4"/>

  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"/>

  <div className="h-4 bg-gray-200 rounded w-1/2"/>

</div>
);

}

export default SkeletonProduct;
